import React, { useContext, useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { doc, getDoc, deleteDoc } from "firebase/firestore";
import { db } from "../firebase";
import ReactPlayer from "react-player";
import ReactMarkdown from "react-markdown";
import { MemberContext } from "../Contexts/MemberContext";
import "./PostDetail.scss";

const PostDetail = () => {
  const { collection, id } = useParams();
  const navigate = useNavigate();
  const { currentUserInfo } = useContext(MemberContext);
  const isAdmin = currentUserInfo?.administrator === true;

  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPost = async () => {
      try {
        const docRef = doc(db, collection, id);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          setPost({ id: docSnap.id, ...docSnap.data() });
        } else {
          setPost(null);
        }
      } catch (err) {
        console.error("取得エラー:", err);
        setPost(null);
      } finally {
        setLoading(false);
      }
    };

    fetchPost();
  }, [collection, id]);

  const handleDelete = async () => {
    if (!window.confirm(`「${post?.title || "この記事"}」を削除しますか？`))
      return;
    await deleteDoc(doc(db, collection, id));
    navigate(`/${collection}`);
  };

  /* ======================
     ファイル判定関数
  ====================== */

  const isZipFile = (url) => {
    if (!url) return false;
    const lowerUrl = url.toLowerCase();
    return lowerUrl.endsWith(".zip") || lowerUrl.includes(".zip?");
  };

  const isPdfFile = (url) => {
    if (!url) return false;
    const lowerUrl = url.toLowerCase();
    return lowerUrl.endsWith(".pdf") || lowerUrl.includes(".pdf?");
  };

  if (loading) return <div className="loading">読み込み中...</div>;
  if (!post) return <div className="error">記事が見つかりません</div>;

  return (
    <div className="post-detail-container">
      <div className="post-detail-content">
        {/* 管理者操作 */}
        {isAdmin && (
          <div className="post-admin-actions">
            <button
              onClick={() =>
                navigate(`/firestoreservice/${id}/edit`, {
                  state: {
                    posttitle: post.title,
                    databasename: collection,
                    targetitems: ["order", "youtubeUrl", "image", "linkUrl"],
                    targetData: post,
                  },
                })
              }
            >
              編集
            </button>

            <button className="danger" onClick={handleDelete}>
              削除
            </button>
          </div>
        )}

        <button className="back-button" onClick={() => navigate(-1)}>
          ← 戻る
        </button>

        <h1 className="post-title">{post.title}</h1>

        {/* YouTube */}
        {post.youtubeUrl && (
          <div className="post-video-wrapper">
            <ReactPlayer
              url={post.youtubeUrl}
              width="100%"
              height="400px"
              controls
            />
          </div>
        )}

        {/* 画像＋本文 横並び */}
        <div className="post-detail-main">
          {/* 画像（左） */}
          {post.image && (
            <div className="post-detail-image-wrapper">
              <img
                src={post.image}
                alt={post.title}
                className="post-detail-image"
              />
            </div>
          )}

          {/* マークダウン本文（右） */}
          <div className="markdown-body">
            <ReactMarkdown>{post.content}</ReactMarkdown>
          </div>
        </div>

        {/* ダウンロード / PDF / リンク */}
        {post.linkUrl && (
          <div className="post-detail-linkurl" style={{ marginTop: "2rem" }}>
            {/* ZIP */}
            {isZipFile(post.linkUrl) && (
              <a
                href={post.linkUrl}
                download
                target="_blank"
                rel="noopener noreferrer"
              >
                <button className="download-zip-btn">
                  📥 アプリをダウンロード（ZIP）
                </button>
              </a>
            )}

            {/* PDF */}
            {isPdfFile(post.linkUrl) && (
              <div className="pdf-viewer">
                {/* <iframe
                  src={post.linkUrl}
                  title="PDF Viewer"
                  width="100%"
                  height="600px"
                  style={{ border: "1px solid #ccc" }}
                /> */}
                <div className="pdf-actions">
                  <a
                    href={post.linkUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    新しいタブでPDFを開く →
                  </a>
                </div>
              </div>
            )}

            {/* その他 */}
            {!isZipFile(post.linkUrl) && !isPdfFile(post.linkUrl) && (
              <a
                href={post.linkUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="external-link"
              >
                関連リンクを開く →
              </a>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default PostDetail;
